import type { TextareaProps, TextInputProps } from '@mantine/core'
import type { ComponentProps, ReactElement } from 'react'

import { AIInputWrapper } from '@/components/AIInputWrapper'

type AIInputWrapperProps = ComponentProps<typeof AIInputWrapper>

// `AIInputWrapper` is typed for `TextInputProps`; `Textarea` works through the
// structurally-compatible subset, so call sites can pass either.
type WrappableInputProps = TextInputProps | TextareaProps

type MaybeAIWrappedProps = {
  /** When `false`, children render as-is (no AIInputWrapper). */
  enabled: boolean
  /** Forwarded to AIInputWrapper when `enabled` is true. */
  wrapperProps: Omit<AIInputWrapperProps, 'children'>
  children: ReactElement<WrappableInputProps>
}

export function MaybeAIWrapped({ enabled, wrapperProps, children }: MaybeAIWrappedProps): ReactElement {
  if (!enabled) return children
  return <AIInputWrapper {...wrapperProps}>{children as ReactElement<TextInputProps>}</AIInputWrapper>
}
